// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"629506b5","210":"ed62e295","404":"2fd1372e","990":"0877dab6"}[chunkId] + ".chunk.js";
};